import EnglishAccessLevels from "./en-access-levels.json"
import EnglishCountries from "./en-countries.json"
import EnglishJobTitles from "./en-job-titles.json"
import EnglishLanguages from "./en-languages.json"
import EnglishNationalities from "./en-nationalities.json"
import EnglishRefLabels from "./en-ref-labels.json"
import EnglishStatus from "./en-status.json"
import EnglishTypes from "./en-type.json"
import English from "./en.json"

export const englishMessages = {
  ...English,
  ...EnglishCountries,
  ...EnglishJobTitles,
  ...EnglishLanguages,
  ...EnglishNationalities,
  ...EnglishRefLabels,
  ...EnglishStatus,
  ...EnglishTypes,
  ...EnglishAccessLevels,
}
